export const LOAD_ARCHIVE_REQUEST = 'LOAD_ARCHIVE_REQUEST';
export const LOAD_ARCHIVE_SUCCESS = 'LOAD_ARCHIVE_SUCCESS';
export const LOAD_ARCHIVE_FAILURE = 'LOAD_ARCHIVE_FAILURE';
